import * as React from "react";
import classnames from "classnames";
/* empty css           */
const Radio = ({
  children,
  className,
  "data-t": dataT,
  ...htmlInputProps
}) => {
  return /* @__PURE__ */ React.createElement("label", { className: classnames("radio", className), "data-t": dataT }, /* @__PURE__ */ React.createElement("input", { type: "radio", className: "radio__input", ...htmlInputProps }), children);
};
export {
  Radio
};
//# sourceMappingURL=Radio.js.map
